<template>
	<div id="app">
		<Header />

		<router-view />

		<ModalHost />
	</div>
</template>

<script>

/**
 * External Dependencies
 */
import { mapActions } from 'vuex';

/**
 * Internal Dependencies
 */
import Header from '@/components/header/header.vue';
import ModalHost from '@/components/popup/modal-host.vue';
import { clearDropdownsOnClick } from '@/utils/use-dropdowns';

export default {
	/**
	 * Name
	 */
	name: 'App',

	/**
	 * Components
	 */
	components: {
		Header,
		ModalHost
	},

	/**
	 * Methods
	 */
	methods: {
		...mapActions('account', ['getUserData']),
	},

	/**
	 * Created
	 */
	created() {
		this.getUserData();
		
		window.addEventListener('click', clearDropdownsOnClick);
	},

	/**
	 * Unmounted
	 */
	unmounted() {
		window.removeEventListener('click', clearDropdownsOnClick);
	}
};
</script>
